import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/home.css";

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="home-container">
      <h1 className="title" >Welcome to PocketJournal</h1>
      <p className="subtitle">Choose where you want to go</p>

      <div className="card-container">
        <div
          className="card savings"
          onClick={() => navigate("/savings")}
        >
          <h2>💰 Savings</h2>
          <p>Add weekly savings & notes</p>
        </div>

        <div
          className="card dashboard"
          onClick={() => navigate("/dashboard")}
        >
          <h2>📊 Dashboard</h2>
          <p>Track progress & totals</p>
        </div>
      </div>
    </div>
  );
}
